import { AutoMap } from "@automapper/classes";
import { TestDTO } from "./test.dto";

export class TestGroupDTO {
    @AutoMap()
    code?: string
    @AutoMap()
    name: string = ''
    @AutoMap()
    position: number = 1;
    @AutoMap()
    isDefault: boolean = false;
    @AutoMap()
    isHidden: boolean = false;
    @AutoMap(() => TestDTO)
    testList: TestDTO[] = []
}